export default {
  "about": {
    "careersDetails": {
      "anqing": "安慶",
      "applyResume": "履歴書を提出",
      "backToPrevious": "前のページに戻る",
      "category": "カテゴリー:",
      "education": "最低学歴:",
      "errors": {
        "getInfoFailed": "情報取得に失敗しました",
        "getJobDetailFailed": "職務詳細の取得に失敗しました",
        "getJobDetailFailedRetry": "職務詳細の取得に失敗しました。後ほど再試行してください",
        "jobNotExist": "職務情報が存在しません",
        "parseInfoFailed": "情報解析に失敗しました"
      },
      "jobDescription": "職務内容",
      "jobRequirements": "応募条件",
      "nationwide": "全国",
      "noJobInfo": "職務情報が存在しません",
      "person": "人",
      "recruitmentCount": "採用人数:",
      "salary": "給与待遇:",
      "suzhou": "蘇州",
      "workLocation": "勤務地:",
      "workYear": "勤務年数:"
    },
    "contact": {
      "address": "住所:",
      "contactInfo": "連絡先",
      "email": "メール:",
      "errors": {
        "getContactFailed": "連絡先データの取得に失敗しました"
      },
      "pageTitle": "お問い合わせ",
      "phone": "電話:",
      "postcode": "郵便番号:"
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "仕事と生活のバランスを提唱",
            "subtitle": "KEEP BALANCED",
            "title": "バランスを保つ"
          },
          "learning": {
            "description": "学習型組織の構築、生涯学習の推進",
            "subtitle": "KEEP LEARNING",
            "title": "学びに終わりなし"
          }
        },
        "category": "カテゴリー:",
        "errors": {
          "getAreaFailed": "勤務地の取得に失敗しました",
          "getAreaFailedRetry": "勤務地の取得に失敗しました。後ほど再試行してください",
          "getCategoryFailed": "職種カテゴリーの取得に失敗しました",
          "getCategoryFailedRetry": "極速快3。職種カテゴリーの取得に失敗しました。後ほど再試行してください",
          "getJobsFailed": "職務リストの極速快3。取得に失敗しました",
          "getJobsFailedRetry": "職務リストの取得に失敗しました。後ほど再試行してください",
          "getNatureFailed": "職務性質の取得に失敗しました",
          "getNatureFailedRetry": "職務性質の取得に失敗しました。後ほど再試行してください"
        },
        "jobCategory": "職種カテゴリー",
                "jobNature": "職務性質",
    "nationwide": "全国",
    "noData": "データなし",
    "noJobs": "関連職務なし",
    "publishDate": "公開日",
    "searchBox": {
  "campusRecruitment": "新卒採用",
      "placeholder": "キーワードを入力",
      "search": "検索",
      "socialRecruitment": "中途採用"
},
"viewDetail": "詳細を見る>",
    "workLocation": "勤務地"
},
"company": {
  "companyIntro": "2003年に中国の蘇州に本社を置いて設立され、多年にわたる革新的な発展を経て、現在では研究開発、生産、販売、サービスを一体化した国家ハイテク企業に成長しました。事業範囲は、生命科学、パーソナルケア、新素材、研究開発向け製品の厳選、検査などをカバーしています。",
      "companyName": "Yacoo株式会社",
      "dataSection": {
    "founded": "設立",
        "globalCustomers": "グローバル顧客",
        "globalPartners": "グローバルパートナー",
        "patents": "国内外特許出願",
        "productionBase": "年間生産能力",
        "salesCountries": "販売国・地域",
        "title": "企業データ",
        "unit": "トン",
        "year": "年"
  },
  "history": {
    "title": "発展の軌跡"
  },
  "honor": {
    "title": "栄誉と資格"
  },
  "pageTitle": "会社概要",
      "subtitle": "亚科股份は、グローバルな医薬化工材料のイノベーションリーダーです。",
      "vision": {
    "mission": {
      "description": "医薬化学材料の技術進歩と革新を推進",
          "title": "ミッション"
    },
    "title": "企業理念",
        "values": {
      "description": "誠実・感謝、責任・勤勉、実務・奮闘、革新・卓越",
          "title": "中核的価値観"
    },
    "vision": {
      "description": "グローバル医薬化学材料のイノベーションリーダーとなる",
          "title": "ビジョン"
    }
  }
},
"production": {
      "intro": "亜科股份（アーコール・コーポレーション）は安定かつ信頼性の高い製造能力を備えています。現時点では、済寧（ジニン）、安慶（アンキン）の 2 か所に生産拠点を建設しており、国際的にトップレベルの生産設備と生産プロセスを配备し、高品質な精製化学製品の研究開発と生産に専念しています。単一拠点の総生産能力はいずれも 10 万トンを超えており、既に ISO9001 品質管理システム、ISO14001 環境管理システム、ISO45001 職業安全衛生管理システムの認証を取得しています。",
      "intro2": "Yacoo株式会社は「ゼロ欠陥」品質管理システムにより、すべての製品が業界の高基準に達することを保証し、グローバル顧客に安定した信頼性の高い化学品供給ソリューションを提供し続けています。規模化された生産能力、スマート生産、全原料管理の競争優位性に基づき、医療健康、バイオテクノロジーなどの戦略的新興産業に「科学研究から商業化生産まで」のワンストップ原料ソリューションを提供し、顧客の安定した発展を支援しています。",
      "siteInfo": {
    "area": "敷地面積:",
        "capacity": "工場と生産能力:",
        "coreProducts": "中核製品:",
        "field": "応用分野:"
  },
  "title": "生産拠点"
},
"quality": {
  "equipment": {
    "description": "高速液体クロマトグラフィー装置、ガスクロマトグラフィー装置、核磁気共鳴装置、旋光計、赤外分光光度計、誘導結合プラズマ発光分光分析装置、自動電位差滴定装置、カールフィッシャー水分計などの包括的な検査機器プラットフォームを構築することで、Yacoo株式会社は顧客のさまざまなシナリオにおける高精度で複雑なリリース検査ニーズを満たすことができます。",
        "devices": {
      "automaticTitrator": "自動電位差滴定装置",
          "broadbandNMR": "広帯域多コイル核磁気共鳴装置",
          "gcms": "GC-MS",
          "icpSpectrometer": "誘導結合プラズマ発光分光分析装置",
          "infraredSpectrometer": "赤外分光極速快3。光度計",
          "karlFischer": "カール極速快3。フィッシャー水分計"
    },
    "title": "検査機器"
  },
  "intro": "Yacoo株式会社はプロセス管理により製品品質を保証極速快3。し、顧客によりコストパフォーマンスの高い多様な製品と優れたサービス極速快3。を提供し、顧客のイノベーションをサポートすることを使命としています。Yacoo株式会社の医薬化学材料分野での22年間の検査経験に基づき、博士号を持つ研究分析チームが率い、顧客に検査から技術最適化までのワンストップソリューションを提供します。",
      "intro2": "Yacoo株式会社の検査プラットフォームは3000㎡の現代的な実験室を有し、国内最先端の空気循環と浄化システムを構築し、検査環境の安全性と管理を確保しています。プラットフォームには包括的な化学分析スペースとフルセットのハイエンド機器が装備されており、高精度で複雑な検査ニーズを満たすことができます。各国/地域の法律規制および技術規範（EU REACH、米国FDA、中国CDEなど）に基づき、顧客が貿易障壁を回避し、製品ライフサイクル全体のコンプライアンス管理を実現するのを支援します。",
      "navigation": {
    "next": "次へ",
        "prev": "前へ"
  },
  "system": {
    "description": "Yacoo株式会社は、構造特性、物理化学的特性、元素分析、スペクトル分析、安定性研究、データの完全性と追跡可能性、不純物分析研究、原材料検査などを含む包括的な医薬化学材料検査システムを確立し、品質管理はGMPシステム、ISO9001:2015品質管理体系認証を取得し、顧客のグローバル市場での開発と応用をサポートしています。",
        "title": "検査システム"
  },
  "title": "品質管理"
}
},
"tabs": {
  "careers": "採用情報",
      "company": "会社概要",
      "production": "生産拠点",
      "quality": "品質管理"
}
},
"dzhc": {
  "businessIntroText": "カスタマイズサービスはYacoo株式会社の中核事業です。医薬化学材料分野での22年間の研究開発経験に基づき、Yacoo株式会社は顧客に信頼性の高いワンストップカスタマイズサービスを提供できます。私たちは経験豊富極速快3。な科学者と極速快3。エンジニアからなる研究開発チームと品質検査チームを擁し、AIインテリジェント合成プラットフォーム、化学合成プラットフォーム、バイオ合成プラットフォームなどの5つの実験プラット極速快3。フォームを構築極速快3。し、高速液体クロマトグラフィー装置、ガスクロマトグラフィ極速快3。ー装置、旋光計などの先進的な検査プラットフォームを装備しています。さらに、Yacoo株式会社は年間生産能力が10万トンを超える2つの生産拠点を有し、医薬化学材料分野の顧客のカスタム合成、CROサービスからCDMOサービスまでの全プロセスニーズを満たすことができます。",
      "businessIntroTitle": "事業概要",
      "businessItems": ["高分子材料", "ポリマー単量体", "医薬中間体", "電子化学新材料", "臨床検査原料"],
      "caseTabs": [
    {
      "title": "医薬化学分野の専門家チーム",
      "description": "100人近い経験豊富な科学者とエンジニアで構成され、修士・博士の専門人材が40%以上、研究開発特許出願が150件以上、承認済みが50件以上。"
    },
    {
      "title": "一流の研究開発・検査プラットフォーム",
      "description": "AIインテリジェント合成プラットフォーム、化学合成プラットフォーム、バイオ合成プラットフォームなどの5つの実験プラットフォームを構築し、高速液体クロマトグラフィー装置、ガスクロマトグラフィー装置、旋光計などの先進的な検査プラットフォームを装備。"
    },
    {
      "title": "国際品質システム保証",
      "description": "ISO国際標準に厳格に準拠極速快3。し、全プロセス品質管理により製品の高信頼性を確保。原料選別から完成品まで、多層検査ポイントと全プロセス品質管理。"
    }
  ],
      "coreBusinessTitle": "中核事業",
      "featureTitle": "サービス特徴",
      "pageSubtitle": "医薬製品CRO+CDMOカスタムサービス",
      "pageTitle": "カスタマイズサービス",
      "processItems": [
    {
      "title": "ルート設計",
      "desc": ["100人以上の経験豊富な研究開発者", "AI支援合成ルート設計"]
    },
    {
      "title": "研究開発と合成",
      "desc": ["10,000㎡以上の研究開発実験室", "80%以上の常用反応をカバー"]
    },
    {
      "title": "サンプル生産",
      "desc": ["200,000㎡以上の工場生産", "厳格な品質管理、品質保証"]
    },
    {
      "title": "分装・発送",
      "desc": ["各種固体/液体分装発送要件を満た極速快3。す", "専門的なサンプル発送/物流追跡"]
    }
  ],
      "processTitle": "カスタム合成プロセス",
      "startProject": "今すぐカスタムプロジェクトを開始",
      "startProjectDesc": "ご要望をお知らせください。専門チームが1対1の技術相談とカスタマイズソリューションを提供します。",
      "viewMore": "さらに見る"
},
"header": {
  "contactUs": "お問い合わせ",
      "menu": {
    "about": "Yacooについて",
        "companyProfile": "会社概要",
        "customSynthesis": "カスタマイズサービス",
        "greenEnergy": "グリーンエネルギー",
        "innovation": "イノベーション成果",
        "joinUs": "採用情報",
        "news": "ニュースセンター",
        "other": "その他事業",
        "production": "生産拠点",
        "products": "製品センター",
        "quality": "品質管理",
        "rAndDSystem": "研究開発体系",
        "researchPurchase": "研究用購入",
        "smartPlatform": "インテリジェントプラットフォーム",
        "solution": "業界ソリューション",
        "sustainability": "持続可能な発展",
        "technology": "研究開発イノベーション",
        "testingService": "検査サービス"
  },
  "searchPlaceholder": "検索内容を入力..."
},
"home": {
  "about": {
    "description": "2003年に中国の蘇州に本社を置いて設立され、多年にわたる革新的な発展を経て、現在では研究開発、生産、販売、サービスを一体化した国家ハイテク企業に成長しました。事業範囲は、生命科学、パーソナルケア、新素材、研究開発向け製品の厳選、検査などをカバーしています。",
        "learnMore": "詳細を見極速快3。る",
        "subtitle": "亚科股份は、グローバルな医薬化工材料のイノベーションリーダーです。",
        "title": "Yacooについて"
  },
  "globalService": {
    "description": "Yacoo株式会社はグローバル顧客にカスタム合成から規模生産までのワンストップCRO+CMOサービスを提供し、科学研究から商業化生産までの全プロセス製品ニーズを満たすことができます。",
        "legend": {
      "customers": {
        "en": "Our Customers",
            "zh": "サービス顧客"
      },
      "headquarters": {
        "en": "Yacoo Headquarter",
            "zh": "Yacoo本社"
      },
      "subsidiaries": {
        "en": "Subsidiary Companies",
            "zh": "Yacoo子会社"
      }
    },
    "stats": {
      "title": "海外展開",
          "capacity": "シンガポール、米国、ドイツに海外子会社を設立",
          "patents": "グローバル顧客数15,000社以上",
          "team": "70以上の国々で事業展開"
    },
    "title": "グローバルサービスネットワーク"
  },
  "news": {
        "searchBtn": " 検索 ",
        "noNews": "関連ニュースなし",
        "pageTitle": "ニュースセンター",
        "searchPlaceholder": "キーワードを入力",
        "title": "Yacoo動向",
        "topTag": "トップ",
        "viewDetail": "詳細を見る",
        "viewMore": "さらに見る"
  },
  "solutions": {
    "title": "製品とソリューション"
  }
},
"jcfw": {
  "actionBtn": "今すぐ相談",
  "businessIntroText1": "万徳検査はYacoo株式会社傘下の独立検査サービスプラットフォームです。Yacoo株式会社の医薬化学材料分野での22年間の検査経験に基づき、万徳検査は国際的な品質サービスプラットフォームの構築に尽力し、CMA資格認定（中国計量認証）とCNAS実験室認可（ISO/IEC17025）に基づ極速快3。き、国内外の製造企業/貿易会社に各種（各国/地域）法律/規制/技術規範の検査サービス、認証および対応するコンサルティングサービスを提供します。顧客に検査から技術最適化までのワンストップソリューション極速快3。を提供します。",
      "businessIntroText2": "万徳検査プラットフォームは3000㎡極速快3。の現代的な実験室を有し、国内最先端の空気循環と浄化システムを構築し、検査環境の安全性と管理を確保しています。プラットフォームには包括的な化学分析スペースとフルセットのハイエンド機器が装備されており、高精度で複雑な検査ニーズを満たすことができます。各国/地域極速快3。の法律規制および技術規範（EU REACH、米国FDA、中国CDEなど）に基づき、顧客が貿易障壁を回避し、製品ライフサイクル全体のコンプライアンス管理を実現するのを支援します。",
      "businessIntroTitle": "事業概要",
      "businessItems": ["検査サービス", "医学研究と試験開発", "検査技術サービス", "認証サービス"],
      "businessItemsClass": ["日用消費財", "電子電気製品", "玩具及び児童用品", "食品接触材料", "自動車材料", "軽工業製品及び繊維製品"],
      "businessTip": "実験室は包括的な検査サービスシステムを確立し、日用消費財、電子電気製品、玩具及び児童用品、食品接触材料、自動車材料、軽工業製品及び繊維製品などの化学的及び物理的検査ニーズを満たすことができます。",
      "caseTabs": [
    {
      "title": "極速快3。コンプライアンス検査認証経験",
      "description": "実験室はYacoo株式会社の医薬分野での22年間の検査サービス経験に基づき、グローバ極速快3。ル製造企業及び貿易業者にコンプライアンス検査、認証及び技術コンサルティングサービスを提供することに尽力しています。"
    },
    {
      "title": "国際標準管理体系認証",
      "description": "検査指標と管理体系は国際品質体系要件に準拠し、多くの国際的な主要顧客の認可を取得し、検査データの権威性と信頼性を確保しています。"
    },
    {
      "title": "検査能力の包括的カバレッジ",
      "description": "消費財化学検査、児童玩具安全評価、繊維製品検査、食品接触材料コンプライアンス検査、自動車材料分析などの分野の包括的なサービスを提供極速快3。し、企業が各国の規制要件（REACH、FDA、CDEなど）に対応するのを支援します。"
    }
  ],
      "contact": {
    "address": "住所:蘇州工業園区新慶路112号8階",
        "email": "連絡先メール:service@wondertesting.cn",
        "phone": "電話:+86-18625246998",
        "postcode": "郵便番号:215121"
  },
  "contactTitle": "お問い合わせ",
      "coreBusinessTitle": "中核事業",
      "equipmentDesc": "高速液体クロマトグラフィー装置、ガスクロマトグラフィー装置、核磁気共鳴装置、旋光計、赤外分光光度計などの包括的な検査機器プラットフォームを構築することで、Yacoo株式会社は顧客のさまざまなシナリオにおける高精度で複雑なリリース検査ニーズを満たすことができます。",
      "equipmentList": ["赤外分光光度計", "広帯域多コイル核磁気共鳴装置", "誘導結合プラズマ発光分光分析装置", "カールフィッシャー水分計", "GC-MS", "自動電位差滴定装置"],
      "equipmentTitle": "検査機器",
      "featureTitle": "サービス特徴",
      "nextBtn": "次へ",
      "pageSubtitle": "独立検査から技術最適化までの統合サービスプロバイダー",
      "pageTitle": "検査サービス",
      "platformDesc": "検査認証統合サービスプロバイダー",
          "prevBtn": "前へ",
      "shopSubtitle": "独立検査から技術最適化までの統合サービスプロバイダ極速快3。ー",
      "shopTitle": "万徳検査",
      "viewMore": "さらに見る"
},
"kycg": {
  "actionBtn": "ソリューションを取得",
  "businessIntroText": "星元素甄选(www.b2star.com)はYacoo株式会社傘下の専門的な研究用品ワンストップ調達電子商取引プラットフォームです。国内外の優良ブランドサプライヤーチャネルを統合し、専門的な研究用試薬、防護用品、バイオ消耗品、実験装置などの関連製品を提供し、国内外の生命科学研究、バイオ医薬品及び新材料分野の顧客の多様化したニーズをより良く満たすことに尽力しています。",
      "businessIntroTitle": "事業概要",
      "businessItems": [
    {
      "title": "研究用試薬",
      "desc": "バイオ試薬、化学試薬、分析試薬、その他試薬"
    },
    {
      "title": "防護用品",
      "desc": "手部防護、頭部防護、面部防護、その他防護"
    },
    {
      "title": "バイオ消耗品",
      "desc": "細胞培養、医療用消耗品、クロマトグラフィー消耗品、検査消耗品、分注消耗品、工具類消耗品"
    },
    {
      "title": "実験装置",
      "desc": "通常機器、検査機器、クロマトグラフィー機器、専用機器、安全施設"
}
],
  "caseTabs": [
    {
      "title": "24時間発送対応",
      "description": "複数倉庫直送、迅速配送"
    },
    {
      "title": "600万+規格製品",
      "description": "ブランド多数、品揃え豊富"
    },
    {
      "title": "600+有名協力ブランド",
      "description": "極速快3。メーカー認可、正規品保証"
    },
    {
      "title": "心遣いのある調達サービス ",
      "description": "お得多数、専門サービス"
    }
  ],
      "contact": {
    "addressSuqian": "住所(宿遷):宿遷市宿豫区電子商取引産業園谷客ビル(A9棟)1階",
        "addressSuzhou": "住所(蘇州):蘇州市工業園区新慶路112号",
        "addressWuhan": "住所(武漢):武漢東湖新技術開発区高新大道766号光谷本部センターT3棟11階07号",
        "addressChengdu": "住所(成都):成都市武侯区武科西一路鼎盛国際3棟706室",
        "email": "メール:sxg@b2star.com",
        "phone": "電話:15335295587"
  },
  "contactTitle": "お問い合わせ",
      "coreBusinessTitle": "中核事業",
      "enterShop": "注文に入る",
      "featureTitle": "サービス特徴",
      "pageSubtitle": "研究調達ワンストッププラットフォーム",
      "pageTitle": "研究調達",
      "shopBusiness": ["研究用試薬", "安全防護", "バイオ消耗品", "実験装置"],
      "shopSubtitle": "研究調達ワンストッププラットフォーム",
      "shopTitle": "星元素甄选"
},
"lsny": {
  "actionBtn": "サンプルを取得",
  "businessIntroText": "古迪娜新能源(www.goodenoughchem.com)是Yacoo株式会社傘下のグリーンエネルギーサービスプラットフォームです。独自開発の難燃性原位置硬化剤は、電池の安全性を効果的に向上させ、多くの主要企業の協力認可を取得しています。新エネルギーリチウム電池材料統合サービスプロバイダーとして、古迪娜新能源は研究ニーズから規模生産までの全方位ニーズを満たし、基礎電解液の調製、電解液原材料及び特殊機能電解液、専門的大量電解液調製/電解液カスタムサービスを提供できます。",
      "businessIntroTitle": "事業概要",
      "businessItems": [
    {
      "title": "電解液"
    },
    {
      "title": "化学試薬"
    },
    {
      "title": "電池材料"
    },
    {
      "title": "特殊機能電解液"
    }
  ],
      "caseTabs": [
    {
      "title": "製品マトリックス豊富",
      "description": "100種類近くの新エネルギーリチウム電池機能添加剤の開発を完了し、リチウム/ナトリウム/マグネシウム/アルミニウム電解液を提供可能"
    },
    {
      "title": "研究開発カスタムから量産まで",
      "description": "10種類以上のリチウム電池機能材料の産業化能力を有し、その中エトキシホスファゼンシリーズ製品は百トンレベルの生産能力を計画"
    },
    {
      "title": "主要企業協力認可",
      "description": "固体難燃剤製品指標は国際水準に達極速快3。し、国内の多くの主要新エネルギー企業の認可を取得"
    }
  ],
      "contactAddress": "住所:蘇州工業園区新慶路112号8階",
      "contactEmail": "メール:sales022@b2star.com",
      "contactPhone": "電話:18136447806",
      "contactPostcode": "郵便番号:215121",
      "contactQQ": "QQ:693755679",
      "contactSubtitle": "新エネルギーリチウム電池材料統合サービスプロバイダー",
      "contactTitle": "お問い合わせ",
      "coreBusinessTitle": "中核事業",
      "enterShop": "詳細を見る",
      "featureTitle": "サービス特徴",
      "pageSubtitle": "新エネルギーリチウム電池材料統合サービスプロバイダー",
      "pageTitle": "グリーンエネルギー",
      "shopSubtitle": "新エネルギーリチウム電池材料統合サービスプロバイダー",
      "shopTitle": "古迪娜新能源"
},
"news": {
      "searchBtn": "検索",
      "filter": "ニュースのカテゴリを絞ります",
      "noNews": "関連ニュースなし",
      "pageTitle": "ニュースセンター",
      "searchPlaceholder": "キーワードを入力",
      "title": "Yacoo動向",
      "topTag": "トップ",
      "viewDetail": "詳細を見る",
      "viewMore": "さらに見る"
},
"products": {
  "centerTitle": "製品センター",
    "screening": "製品の種類を選別します",
      "detail": {
    "advantages": "サービス優位性",
        "batchInquiry": "一括購入見積依頼",
        "breadcrumbCenter": "製品センター",
        "breadcrumbHome": "ホーム",
        "cas": "CAS番号:{cas}",
        "customSynthesis": "カスタム合成相談",
        "featured": "人気製品推薦",
        "features": "製品特徴",
        "getSample": "サンプル取得",
        "noData": "データなし",
        "notes": "備考",
        "related": "関連製品推薦",
              "researchPurchase": "研究調達"
  },
  "mainProducts": "主要製品",
      "noData": "データなし",
      "searchBtn": "検索",
      "searchPlaceholder": "製品名、品番、CAS番号またはキーワードを入力",
      "panel": {
    "EnglishName": "英語名",
        "Name": "製品名",
        "Alias": "別名",
        "CAS": "CAS番号",
        "UsagePlatform": "応用プラットフォーム",
        "ArtNo": "品番",
        "molecularFormula": "分子式",
        "molecularWeight": "分子量",
        "ec": "EC番号",
        "enzymeActivity": "酵素活性",
        "activity": "活性"
  }
},
"solution": {
      "learnMore": "詳細を見る",
      "pageSubtitle": "医薬化学材料の技術進歩と革新を推進",
      "pageTip": "亜科股份（アーコール・コーポレーション）は常に医薬・化学材料の技術進歩と革新を推進することに注力しています。技術革新と安定した供給を基盤として顧客の専門的ニーズを満たし、高品質、利便性が高く、コストパフォーマンスに優れた多様な製品とサービスを提供しています。これにより医薬・化学材料産業の持続的な進歩を推進し、グリーンで健康的な未来を共に構築していきます。",
      "pageTitle": "業界ソリューション",
      "tableName": "名称"
},
"sustainability": {
  "conceptText": "Yacoo株式会社は常に持続可能な発展理念を堅持し、グリーンイノベーションを研究開発、生産と運営の全プロセスに組み込んでいます。私たちは環境保護プロセスの最適化、資源循環利用及びクリーンエネルギー応用を通じてカーボンフットプリントを削減することに尽力しています。技術革新により生分解性材料とグリーンソリューションの開発を推進し、業界の低炭素転型を支援します。同時に、私たちは積極的に社会的責任を実践し、従業員、コミュニティ及び環境との共生共栄システムを構築し、経済的利益、生態的利益と社会利益極速快3。の協調性発展を追求し、グローバル持続可能な開発目標に貢献します。",
      "conceptTitle": "持続可能な発展理念",
      "dataSection": {
    "highConcentrationGas": "グリーン電力使用比率",
        "lowConcentrationGas": "二酸化炭素換算量/百万元",
        "solidWasteStorage": "新疆クズルス二中図書寄贈",
        "wastewaterTreatment": "2024年社会寄付金",
        "units": {
      "cubicMeterPerHour": "%",
          "ton": "トン",
          "tonPerDay": "冊",
          "yuan": "元"
    }
  },
  "environmentalProtection": {
    "altText": "環境保護",
        "description": "Yacoo株式会社は国家と地方の環境保護に関する関連法律法規及びその他の規定を厳格に遵守し、ISO14001環境管理体系認証を取得しています。完備した三廃処理施設を有し、先進的な廃水、廃ガスと固形廃棄物処理施設を導入することで、環境に優しい前提で安全に生産活動を展開できます。",
        "title": "環境保護"
  },
  "greenDevelopment": {
    "buildingAlt": "Yacoo株式会社本社ビル",
        "description": "「医薬化学の境界を超え、グリーンな未来を共創する」という企業の初心を堅持し、Yacoo株式会社はインフラ建設から製品開発まで常にグリーン発展を使命としています。グループ本社ビルは米国グリーンビルディング協会からLEED（エネルギーと環境設計先導）プラチナ認証を取得し、ソーラーパネルなどのグリーン電力設備でエネルギー供給を実現しています。Yacoo株式会社は再生可能な農作物から生産されるバイオベース新材料ポリ2,5-フランジカルボン酸エチレンジオール（PEF）を基盤としており、ボトル分野に広く応用可能で、製品生産プロセス全体のカーボンフットプリントを大幅に削減できます。",
        "title": "グリーン発展"
  },
  "pageSubtitle": "医薬製品CRO+CDMOカスタムサービス",
      "pageTitle": "持続可能な発展",
      "safetyProduction": {
    "certificateAlt": "環境認証証明極速快3。書",
        "description": "YacooはISO45001職業健康安全管理体系要件を参照し、完備した安全生産管理体系を制定しました。情報化とインテリジェント化施設を通じて、安全生命線を守ります。Yacoo安慶生産拠点を例にとると、この拠点は生産安全標準化三級認証を取得し、安全生産情報化システムを構築し、人員位置確認、インテリジェント巡回検査、二重予防などの五位一体の安全リスク防止管理体系を実現しました。",
        "title": "安全生産"
  }
},
"technology": {
  "achievementsTitle": "イノベーション成果",
      "businessIntroText": "Yacoo株式会社は1万平方メートル以上の研究開発センターを有し、AI合成プラットフォーム、マイクロチャンネル連続流反応器などの先端設備を装備し、修士・博士を中核とする100人以上の研究開発極速快3。チームを編成しています。中国科学院寧波材料研究所、蘇州大学などの高等教育機関との深い産学研協力を通じて、「江蘇省工程技術研究センター」「JITRI-Yacoo共同イノベーションセンター」などのイノベーションプラットフォームを設立し、完備した研究開発と成果転化体系を形成しています。現在までに、企業は150件以上の特許を出願しています。",
      "businessIntroTitle": "完備した研究開発体系",
      "businessItems": [
    {
      "title": "生物医学浄化剤と構造性化学品"
    },
    {
      "title": "高級体外診断試薬開発"
    },
    {
      "title": "生物酵素開発"
    },
    {
      "title": "高級生物ポリマ極速快3。ー材料開発"
    },
    {
      "title": "半導体級電子化学品と新エネルギー電池材料"
    }
  ],
      "consultBtn": "カスタム相談",
      "customServiceDesc": "医薬化学材料分野での22年間の研究開発経験に基づき、Yacoo株式会社は顧客に信頼性の高いカスタム合成サービスを提供できます。",
      "customServiceTitle": "グラム単位からトン単位までのカスタマイズサービス",
      "leadingProcess": "先導プロセス",
      "pageTitle": "知駆科技 未来を創造",
      "platformList": [
    {
      "title": "AIインテリジェント実験室",
      "description": "AIインテリジェント合成実験室はAIインテリジェント合成装置を装備し、反応ステップとパラメータをカスタマイズでき、反応プロセスをリアルタイムで監視し、プロセス条件の迅速なスクリーニング極速快3。と最適反応条件予測を実現し、研究開発効率を向上させます。"
    },
    {
      "title": "高級試薬精製実験室",
      "description": "薬剤級化学品と半導体級電子材料の精製に使用されます。実験室は先進的な精製設備を装備極速快3。し、酸、アルコール、アミン、ニトリル類などの化合物に対して蒸留、膜濾過精製技術実験を行えます。"
    },
    {
      "title": "新エネルギー電解質専用実験室プラットフォーム",
      "description": "プラットフォームは電解液難燃剤と電解質実験を行えます。**設備を装備し、ホスファゼン類難燃剤の研究開発作業に成功しました。顧客の電池の技術パスに応じて、液体、半液体電池材料の持続的開発が可能です。"
    },
    {
      "title": "生物合成グリーン技術実験室プラットフォーム",
      "description": "生物合成は常温常圧で進行し、低エネルギー消費で、有機溶媒を必要とせず、有毒副産物を減少または発生させません。このプラットフォームは酵素触媒法に基づく生物緩衝剤製品の開発、新診断基質と高分子ポリエステル材料の開発を行っています。"
    },
    {
      "title": "化学合成実験室プラットフォーム",
      "description": "化学合成実験室は従来の合成設備に加え、核磁気共鳴（NMR）、質量分析（MS）、高速液体クロマトグラフィー（HPLC）、マイクロチャンネル連続流自動合成ワークステーション、実験室データ管理システム（LIMS）を装備しています。薬用添加剤、診断基質と高分子複合材料開発を含む顧客カスタ極速快3。ム開発を完了できます。"
    }
  ],
      "platformTitle": "五大インテリジェント研究開発プラットフォーム",
      "serviceIcons": [
    "生物医学浄化剤と構造性化学品",
    "高級体外診断試薬開発",
    "生物酵素開発",
    "高級生物ポリマー材料開発",
    "半導体級電子化学品と新エネルギー電池材料"
  ],
      "starProduct": "イノベーション製品"
},
"footer": {
  "contact": {
    "phone": "電話",
        "email": "メール"
  },
  "qrCode": {
    "scanToFollow": "スキャンしてフォロー"
  },
  "socialMedia": {
    "wechat": "WeChat",
        "tiktok": "TikTok",
        "xiaohongshu": "小红书"
  },
  "copyright": "©2025 蘇州Yacoo科技株式会社",
  "icp": "蘇ICP備15045967号"
},
"croCdmoDialog": {
  "logoAlt": "Yacooロゴ",
      "hotline": "無料サービスホットライン:",
      "description": "ご要望情報を残してください。1営業日以内にご連絡いたします",
      "form": {
    "name": "氏名",
    "namePlaceholder": "氏名を入力してください",
        "contact": "連絡極速快3。先",
        "contactPlaceholder": "電話/携帯番号/メールを入力してください",
        "company": "会社名",
        "companyPlaceholder": "会社名を入力してください",
        "product": "製品名",
        "productPlaceholder": "製品名を入力してください",
        "cas": "CAS番号",
        "casPlaceholder": "CAS番号を入力してください",
        "requirement": "調達要望",
        "requirementPlaceholder": "調達要望を入力してください",
        "attachment": "添付ファイル",
        "submit": "提出"
  },
  "upload": {
    "clickToUpload": "クリックして添付ファイルをアップロード",
        "fileFormat": "ファイル形式:jpg、pdf、doc、ファイルサイズ5M以下",
        "fileSizeError": "ファイルサイ極速快3。ズは5Mを超えてはいけません",
        "fileTypeError": "jpg、pdfまたはdoc形式のファイルをアップロードしてください",
        "uploadSuccess": "ファイルアップロード成功",
        "uploadFailed": "ファイルアップロード失敗、再試行してください"
  },
  "validation": {
    "nameRequired": "氏名を入力してください",
        "contactRequired": "連絡先を入力してください",
        "casRequired": "CAS番号を入力してください"
  },
  "messages": {
    "submitSuccess": "提出成功",
        "submitFailed": "提出失敗",
        "submitFailedRetry": "提出失敗、後ほど再試行してください"
  }
},
"productDialog": {
  "logoAlt": "Yacooロゴ",
      "hotline": "無料サービスホットライン:",
      "description": "ご要望情報を残してください。1営業日以内にご連絡いたします",
      "form": {
    "name": "氏名",
        "namePlaceholder": "氏名を入力してください",
        "contact": "連絡先",
        "contactPlaceholder": "電話/携帯番号/メールを入力してください",
        "company": "会社名",
        "companyPlaceholder": "会社名を入力してください",
        "product": "製品名",
        "productPlaceholder": "製品名を入力してください",
        "cas": "CAS番号",
        "casPlaceholder": "CAS番号を入力してください",
        "requirement": "調達要望",
        "requirementPlaceholder": "調極速快3。達要望を入力してください",
        "submit": "提出"
  },
  "validation": {
    "nameRequired": "氏名を入力してください",
        "contactRequired": "連絡先を入力してください",
        "casRequired": "CAS番号を入力してください"
  },
  "messages": {
    "submitSuccess": "提出成功",
        "submitFailed": "提出失敗",
        "submitFailedRetry": "提出失敗、後ほど再試行してください"
  }
},
"serviceDialog": {
  "logoAlt": "Yacooロゴ",
      "hotline": "無料サービスホットライン:",
      "description": "ご要望情報を残してください。1営業日以内にご連絡いたします",
      "form": {
    "name": "氏名",
        "namePlaceholder": "氏名を入力してください",
        "contact": "連絡先",
        "contactPlaceholder": "電話/携帯番号/メールを入力してください",
        "company": "会社名",
        "companyPlaceholder": "会社名を入力してください",
        "service": "サービス名",
        "servicePlaceholder": "サービス名を入力してください",
        "requirement": "要望詳細",
        "requirementPlaceholder": "カスタム要望を入力してください",
        "submit": "提出"
  },
  "validation": {
    "nameRequired": "氏名を入力してください",
        "contactRequired": "連絡先を入力してください"
  },
  "messages": {
    "submitSuccess": "提出成功",
        "submitFailed": "提出失敗",
        "submitFailedRetry": "提出失敗、後ほど再試行してください"
  }
},
"productDownloadDialog": {
  "logoAlt": "Yacooロゴ",
  "title": "ドキュメントダウンロード情報",
  "description": "ドキュメントをダウンロードするために以下の情報を入力してください",
  "form": {
    "companyName": "会社名",
    "companyNamePlaceholder": "会社名を入力してください",
    "email": "メール",
    "emailPlaceholder": "メールを入力してください",
    "mobile": "電話",
    "mobilePlaceholder": "電話番号を入力してください",
    "qq": "QQ",
    "qqPlaceholder": "QQを入力してください（任意）",
    "wechat": "WeChat",
    "wechatPlaceholder": "WeChatを入力してください（任意）",
    "submit": "提出"
  },
  "validation": {
    "companyNameRequired": "会社名を入力してください",
    "emailRequired": "メールを入力してください",
    "emailInvalid": "有効なメールアドレスを入力してください",
    "mobileRequired": "電話番号を入力してください"
  },
  "messages": {
    "submitFailed": "提出失敗",
    "submitFailedRetry": "提出失敗、後ほど再試行してください"
  }
},
"purchaseDialog": {
  "logoAlt": "Yacooロゴ",
      "title": "その他のブランド製品は星元素甄选で",
      "gotoStore": "商城へ移動",
      "storeInfo": "Yacooグループ傘下星元素甄选がサービスを提供"
},
"purchaseListDialog": {
  "logoAlt": "Yacooロゴ",
      "productInfo": "製品情報",
      "unitPrice": "単価(税込)",
      "more": "その他",
      "productCode": "商品番号:",
      "itemNumber": "品番:",
      "specification": "規格:",
      "parameter": "パラメータ:",
      "contactSales": "営業に問い合わせ",
      "gotoShop": "商城へ移動",
      "storeInfo": "Yacooグループ傘下星元素甄选がサービスを提供"
},
"resumeDialog": {
  "logoAlt": "Yacoo",
      "upload": {
    "clickToUpload": "クリックして履歴書をアップロード",
        "fileFormat": "ファイル形式:jpg、pdf、ppt、ファイルサイズ5M以下",
        "fileSizeError": "ファイルサイズは5Mを超えてはいけません",
        "fileTypeError": "jpg、pdfまたはppt形式のファイルをアップロードしてください"
  },
  "fileInfo": {
    "removeFile": "ファイル削除"
        },
  "submit": "送信",
      "messages": {
    "uploadSuccess": "履歴書提出成功",
        "uploadFailed": "アップロード失敗、再試行してください",
        "jobNotExist": "職務情報が存在しません",
        "pleaseUploadFirst": "まず履歴書をアップロードしてください"
  }
},
"goodChart": {
  "logoAlt": "Yacooロゴ",
      "companyName": "Yacoo株式会社",
      "consultationPhone": "相談電話:",
      "productService": "製品相談とアフターサービス:",
      "contactEmail": "連絡先メール:",
      "leaveMessage": "メッセージを残す"
},
"searchPage": {
  "pageTitle": "サイト全体検索",
      "searchInfo": "検索:{keyword}",
      "loading": "読み込み中...",
      "noData": "データなし",
      "noNews": "関連ニュースなし",
      "noProducts": "関連製品なし",
      "productInfo": {
    "casNo": "CAS番号:",
        "itemNumber": "品番:",
        "specification": "規格:",
        "parameter": "パラメータ:",
        "price": "価格:",
        "unit": "単位:",
        "inquiry": "問い合わせ",
        "chemicalName": "化学名"
  },
  "newsInfo": {
    "typeTag": "タイプタグ"
  },
  "pagination": {
    "prev": "前へ",
        "next": "次へ"
  }
}
}
